import { Box, Link } from "@mui/material";
import { Link as RouterLink, useSearchParams } from "react-router-dom";

export const LoginTokenLink = () => {
	const [searchParams] = useSearchParams();
	const search = searchParams.toString();

	return (
		<Link component={RouterLink} to={search ? `/login-token?${search}` : "/login-token"} data-testid="login-token-link">
			<Box sx={{ position: "absolute", bottom: 0, right: 0, height: 40, width: 40, cursor: "pointer" }} />
		</Link>
	);
};
